/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Product Tools

define('modules/Product/ItemTools',[
    'jquery',
    'global/all',
    'modules/Favorites/FavoritesManager'
], function ($, Roc, FavoritesManager) {
    'use strict';

    function getGroupId() {
        return $('#hdnGroupId').val();
    }

    function getUomId() {
        return $('#selectedUom').val();
    }

    function updateHeartIcon(productId, selected) {
        var $heart = $('.roc-itemTools-menu[data-product-id="' + productId + '"]')
            .next('span.icon-heart');

        if (selected) {
            $heart.addClass('status-active');
        } else {
            $heart.removeClass('status-active');
        }
    }

    function productSelectionsUpdate(product) {
        var productId = getGroupId() || product.id;
        FavoritesManager
            .isProductSavedToFavorites(product.id)
            .done(function (resp) {
                updateHeartIcon(productId, resp);
            }).fail(function () {
                updateHeartIcon(productId, false);
            });
    }

    function favoritesListAdded(data) {
        if (data.Result === true && data.id) {
            $('ul.roc-favoritesMenu').each(function () {
                $(this).prepend('<li><button class="btn btnText addItem" data-listid="' + data.id + '">' + data.name + '</button></li>');
            });
        }
    }

    function itemFavorited(data) {
        Roc.UI.unblock();
        if (data.Result === true) {
            Roc.UI.info('Item added to your favorites list');

            var productId = data.groupId || data.productId;
            updateHeartIcon(productId, true);

        } else {
            Roc.UI.displayErrorPopup('There was an error while trying to add a product to your favorites list. Please try again later.');
        }
    }

    function redirectToLoginToAddFavoriteItemEvt() {
        $(document).on('click', 'a.loginToAddItem', function (e) {
            var $selections = $('#hdnProductId');
            if ($selections.length === 1 && $selections.val().length > 0) {
                e.preventDefault();
                var productId = $selections.val();
                var urlParam = 'productId';
                var href = $(this).attr('href');
                var startIndex = href.indexOf(urlParam);
                var newUrl = href.substring(0, startIndex) + urlParam + '=' + productId;
                location.href = newUrl;
            }
        });
    }

    function addItemToFavoritesEvt() {
        $(document).on('click', '.roc-favoritesMenu .addItem', function () {
            var productId = $(this).closest('.roc-itemTools-menu').attr('data-product-id');
            var $selections = $('#hdnProductId');

            if ($selections.length === 1 && $selections.val()) {
                productId = $selections.val();
            }

            var groupId = getGroupId();
            var uomId = getUomId();

            var listId = $(this).attr('data-listid');
            FavoritesManager.addItem(productId, listId, 1, groupId, uomId);
            $('.roc-itemTools .roc-active').removeClass('roc-active');
            Roc.UI.block();
        });
    }

    function createFavoritesListAndAddItemEvt() {
        $(document).on('click', '.roc-createFavorites .createList', function () {
            var productId = $(this).closest('.roc-itemTools-menu').attr('data-product-id');
            FavoritesManager.addListAndMoveItem(productId, getUomId());
        });

        $(document).on('click', '#exportsearch', function () {
            var endpoint = window.RocConfig.api.baseRocApiUrl + '/api/rocsearch/exportresults'
            $.ajax({
                url: endpoint,
                type: 'GET',
                dataType: 'binary',
                processData: false,
                responseType: 'arraybuffer',
                success: function (data, status, xhr) {
                   if (data.length === 0) {
                        Roc.UI.displayErrorPopup("There was an error in exporting the data, please try again.");
                        return;
                    }
                    var filename = "SearchResults.csv";
                    Roc.Extensions.saveFile(data, filename);
                },
                complete: function (data) {
                    Roc.Logger.debug('Data:', data);
                    
                },
                error: function (data, status, errorthrown) {
                   Roc.Logger.error('Export serch data failed:', errorthrown, data);
                }
            });
        });
    }

    function bindEvents() {
        addItemToFavoritesEvt();
        redirectToLoginToAddFavoriteItemEvt();
        createFavoritesListAndAddItemEvt();
        Roc.EventManager.bind(Roc.Events.favorites.ADD_LIST, favoritesListAdded);
        Roc.EventManager.bind(Roc.Events.favorites.ADD_ITEM, itemFavorited);
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, productSelectionsUpdate);
    }

    function init() {
        var toolTimer;

        function ItemToolsHandler(e) {
            if ($(e.target).parents('.roc-itemTools').length <= 0) {
                $('.roc-itemTools .roc-active').removeClass('roc-active');
                $('body').off('click touchstart', ItemToolsHandler);
            };
        };

        // click function to display menu
        $('#site-container').on('click', '.roc-itemTools-option [class*=icon-], .roc-itemTools-option .roc-itemTools-header', function (e) {
            var currentItem = $(e.currentTarget).closest('.roc-itemTools-option');

            // check to see if menu exists
            if (currentItem.find('.roc-itemTools-menu').length >= 1) {
                e.preventDefault();
                currentItem.toggleClass('roc-active');
            };

            $('body').on('click touchstart', ItemToolsHandler);

            // set up auto closing of menu where applicable
            currentItem.on('mouseenter mouseleave', function (e) {
                if (e.type === 'mouseenter') {
                    window.clearTimeout(toolTimer);
                } else {
                    toolTimer = window.setTimeout(function () {
                        currentItem.closest('.roc-active').removeClass('roc-active');
                    }, 1000);
                }
            });
        });

        bindEvents();
    }

    var ItemTools = {
        init: init
    };

    Roc.Logger.debug('ItemTools.js Loaded:', ItemTools);

    return ItemTools;
});
